import * as React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Box, Divider } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";

const TemplateUploadFormModal: React.FC<{
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  confirmSubmit: () => void;
  json: string;
}> = ({ open, setOpen, confirmSubmit, json }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        maxWidth={"md"}
        fullWidth={true}
        onClose={handleClose}
        aria-labelledby="upload-json"
        data-testid={"json-modal"}
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="upload-json-title">
          Upload Profile Confirmation
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <Divider />
        <DialogContent>
          JSON Upload Preview
          <Box
            component={"pre"}
            data-testid={"json-preview"}
            sx={{
              border: "1px solid #ced4da",
              borderRadius: "5px",
              maxHeight: "300px",
              overflow: "scroll",
              padding: "10px",
            }}
          >
            {json}
          </Box>
          Are you sure you want to upload this profile?
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            data-testid={"upload-cancel-button"}
            color="inherit"
            size="medium"
            variant="contained"
            autoFocus
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            data-testid={"upload-confirm-button"}
            size="medium"
            variant="contained"
            autoFocus
            onClick={confirmSubmit}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TemplateUploadFormModal;
